import React from "react"

function Intervention({ intervention }) {
  return (
    <tr>
      <td>{intervention.date}</td>
      <td><i className="material-icons context-icons">flash_on</i> {intervention.type}</td>
      <td> {intervention.ServicesAditionnel.map(service => service)}</td>
    </tr>
  )
}

export default Intervention